import React from "react";
import { Icons } from "prefab";
import styles from "../../styles/Search.module.scss";

const { SearchIcon: Search } = Icons;
const SearchIcon = () => <Search className={`${styles.searchIcon} ${styles.left}`} />;

export { SearchIcon };
